import { inject } from '@angular/core';
import { CanDeactivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DeactivationConfirmationService } from '../../services/deactivation-confirmation/deactivation-confirmation.service';

/**
 * Guard that prevents navigation away from a component with unsaved changes
 * Shows a confirmation modal before allowing navigation
 *
 * To skip this guard, pass byPassDeactivateGuard: true in navigation state:
 * router.navigate(['/path'], { state: { byPassDeactivateGuard: true } });
 */
export const canDeactivateForm: CanDeactivateFn<unknown> = ():
  boolean | Observable<boolean> => {
  const router = inject(Router);
  const deactivationService = inject(DeactivationConfirmationService);

  // Check for byPassDeactivateGuard state
  const navigation = router.currentNavigation();
  const byPassDeactivateGuard =
    navigation?.extras?.state?.['byPassDeactivateGuard'];

  if (byPassDeactivateGuard) {
    return true;
  }

  // Show confirmation modal
  return deactivationService.showConfirmationModal();
};
